export function fullFillStringWithPlaceholder(string: string, placeholder: string | number): string {
  if (typeof string !== 'string') {
    return '';
  }
  return string.replace(/%\w+%/g, placeholder.toString());
}
